import { createApi } from '@reduxjs/toolkit/query/react';
import generateBaseQuery from '../../shared/generateBaseQuery';

export const apiSlice = createApi({
  reducerPath: 'api',
  tagTypes: ['Dashboards', 'DashboardCards', 'DashboardChart', 'Favorite', 'FeasibleVoices', 'Settings'],
  baseQuery: generateBaseQuery(),
  endpoints: () => ({}),
});
